import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';

export default function PaymentError() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-amber-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-red-200" data-testid="payment-error-page">
        <CardContent className="p-8 text-center space-y-4">
          <XCircle size={56} className="mx-auto text-red-500" weight="fill" />
          <h1 className="font-outfit text-2xl font-bold text-red-600">
            {language === 'fr' ? 'Paiement échoué' : 'Payment failed'}
          </h1>
          <p className="text-sm text-slate-700">
            {language === 'fr'
              ? 'Le paiement n\'a pas pu être finalisé. Vous pouvez réessayer ou choisir un autre moyen de paiement.'
              : 'The payment could not be completed. You can retry or pick another method.'}
          </p>
          <Button onClick={() => navigate('/parent')} className="bg-red-500 hover:bg-red-600 text-white">
            {language === 'fr' ? 'Retour au tableau de bord' : 'Back to dashboard'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
